export default "__VITE_ASSET__CgR4R8hs__"